var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpiderimgActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "web-crawler",
    transform: "translate(-1.107 -0.357)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10909",
    "data-name": "Rectangle 10909",
    width: 40,
    height: 40,
    rx: 5,
    transform: "translate(1.107 0.357)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48215",
    "data-name": "Path 48215",
    d: "M32.715,20.909l-.454-.389a.6.6,0,0,0,.181.92Zm-5.724,0,.273.532a.6.6,0,0,0,.181-.92Zm6.178.388a4.348,4.348,0,0,0,1.046-2.834h-1.2a3.153,3.153,0,0,1-.759,2.058Zm1.046-2.834A4.362,4.362,0,0,0,29.852,14.1v1.2a3.167,3.167,0,0,1,3.167,3.167ZM29.852,14.1a4.362,4.362,0,0,0-4.362,4.362h1.2A3.167,3.167,0,0,1,29.852,15.3ZM25.49,18.463A4.348,4.348,0,0,0,26.536,21.3l.908-.777a3.152,3.152,0,0,1-.759-2.058Zm-1.314,8.032a5.677,5.677,0,0,1,3.088-5.054l-.546-1.063a6.872,6.872,0,0,0-3.737,6.117Zm5.677,5.677a5.677,5.677,0,0,1-5.677-5.677h-1.2a6.872,6.872,0,0,0,6.872,6.872Zm5.677-5.677a5.677,5.677,0,0,1-5.677,5.677v1.2a6.872,6.872,0,0,0,6.872-6.872ZM32.442,21.44a5.677,5.677,0,0,1,3.088,5.054h1.2a6.872,6.872,0,0,0-3.738-6.117Z",
    transform: "translate(-8.907 -5.635)",
    fill: "#ef0078"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48216",
    "data-name": "Path 48216",
    d: "M44.981,36.1l4.769,2.51v5.271",
    transform: "translate(-17.76 -14.488)",
    fill: "rgba(0,0,0,0)",
    stroke: "#ef0078",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48217",
    "data-name": "Path 48217",
    d: "M44.053,49.226l1.757-6.275-2.51-2.3",
    transform: "translate(-17.084 -16.319)",
    fill: "rgba(0,0,0,0)",
    stroke: "#ef0078",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48218",
    "data-name": "Path 48218",
    d: "M44.981,26.661l4.769-2.51V18.88",
    transform: "translate(-17.76 -7.559)",
    fill: "rgba(0,0,0,0)",
    stroke: "#ef0078",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48219",
    "data-name": "Path 48219",
    d: "M42.46,21.785l3.012-2.51L43.715,13",
    transform: "translate(-16.746 -5.193)",
    fill: "rgba(0,0,0,0)",
    stroke: "#ef0078",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48220",
    "data-name": "Path 48220",
    d: "M20.769,36.1,16,38.61v5.271",
    transform: "translate(-6.098 -14.488)",
    fill: "rgba(0,0,0,0)",
    stroke: "#ef0078",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48221",
    "data-name": "Path 48221",
    d: "M23.218,49.226l-1.757-6.275,2.51-2.3",
    transform: "translate(-8.296 -16.319)",
    fill: "rgba(0,0,0,0)",
    stroke: "#ef0078",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48222",
    "data-name": "Path 48222",
    d: "M20.769,26.661,16,24.151V18.88",
    transform: "translate(-6.098 -7.559)",
    fill: "rgba(0,0,0,0)",
    stroke: "#ef0078",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48223",
    "data-name": "Path 48223",
    d: "M24.473,21.785l-3.012-2.51L23.218,13",
    transform: "translate(-8.296 -5.193)",
    fill: "rgba(0,0,0,0)",
    stroke: "#ef0078",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48227",
    "data-name": "Path 48227",
    d: "M21.266,26.846c-2.841,0-6.394-1.065-6.394-4.617s.237-4.381,1.421-5.446a7.669,7.669,0,0,0,1.657-2.013S16.53,11.1,19.372,9.8s4.973.118,4.854,2.013a21.372,21.372,0,0,1-.592,3.67s3.789,1.3,3.434,5.091S24.107,26.846,21.266,26.846Z",
    fill: "#ef0078"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiderimgActive);
export default __webpack_public_path__ + "static/media/spiderimg_active.69554a3a6b792635726578b09031490a.svg";
export { ForwardRef as ReactComponent };